import { cls } from "@wss/cls";
import React, { forwardRef, useState } from "react";

export interface CompareProductsToggleProps {
  onChange: (active: boolean) => void;
}

const CompareProductsToggle = forwardRef<
  HTMLButtonElement,
  CompareProductsToggleProps
>(({ onChange }, ref) => {
  const [active, setActive] = useState(false);

  const handleClick = (event: React.SyntheticEvent) => {
    event.preventDefault();
    setActive(!active);
    onChange(!active);
  };

  return (
    <div
      className="hidden md:flex items-center"
      data-testid="compare-products-toggle-wrapper"
    >
      <span
        className="w-28 h-4 font-semibold text-xs"
        data-testid="compare-products-toggle-label"
      >
        Compare Products
      </span>

      <button
        type="button"
        role="switch"
        data-testid="compare-products-toggle-button"
        aria-label="Compare products toggle, when compare products is on, you can select the checkbox for each item, then go to the Compare Products section and select the Compare link"
        aria-checked={active}
        onClick={handleClick}
        ref={ref}
        className={cls(
          "flex items-center top w-[50px] h-5 p-0 m-0 border-none rounded-full",
          active
            ? "bg-[#FBD38D] shadow-[0_0_0_1px_inset_#C05621]"
            : "bg-gray-50 shadow-[0_0_0_1px_inset_#454C40]",
        )}
      >
        {active && <div className="pl-2 z-0 text-[13px]">On</div>}
        <div
          className={cls(
            "absolute box-border w-5 h-5 z-10 border border-solid rounded-full bg-white transition-all",
            active ? "ml-[30px] border-[#C05621]" : "ml-0 border-gray-700",
          )}
        />
        {!active && <div className="pl-6 z-0 text-[13px]">Off</div>}
      </button>
    </div>
  );
});

export default CompareProductsToggle;
